export enum DateFormat {
  Long = "long",
  Short = "short",
}

export const formatDate = (date: Date, includeTime: boolean, format: DateFormat, includeYear?: boolean): string => {
  let options: Intl.DateTimeFormatOptions;

  if (includeTime) {
    options = {
      day: "numeric",
      month: format,
      hour: "numeric",
      minute: "numeric",
      hour12: true
    };
  } else if (includeYear) {
    options = {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }
  } else {
    options = {
      weekday: format,
      day: "numeric",
      month: format,
    };
  }

  // Format the date according to the options
  const formatter = new Intl.DateTimeFormat("en-GB", options);
  const formattedDate = formatter.format(date) + (includeYear ? '' : '').replace(",", "");
  
  return formattedDate;
};

export const formateDateTimeForLastSeen = (date: Date) => {

  const dateObject = new Date(date);

  const formattedDate = dateObject.toLocaleString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour12: true
  });

  return formattedDate
}

export const formateDateForPromoterGroups = (inputDate: Date) => {

  const date = new Date(inputDate);

  const options = {
    weekday: "long",
    day: "numeric",
    month: "long",
  } as const;

  let formattedDate = new Intl.DateTimeFormat("en-US", options).format(
    date
  );
  let dateArray = formattedDate.split(" ");
  
  dateArray = [dateArray[0], dateArray[2], dateArray[1]];
  formattedDate = dateArray.join(" ").replace(",", "");

  return formattedDate;
}